import React, { useState, useRef, useEffect } from 'react';
import { Button, Grid, makeStyles, TextField, Typography, withStyles } from '@material-ui/core';
import { FormModalStyles } from './styles';
import Modal from '../../../common/Modal';
import LoadingScreen from '../../../../collums-components/components/common/loadingScreen';
import { PropTypes } from 'prop-types';
import { modalsButtonStyles } from '../../../../collums-constants/styles/stylesheets/buttonsStyles';
import TemplatesApi from '../../../../api/templatesApi';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import customDropdownSearch from '../../../../collums-components/helpers/customDropdownSearch';
import { getAllFormsByType } from '../../../../collums-components/api/FormApi';
import queryString from 'query-string';
import SMSEditor from '../../../smsEditor/SMSEditor';
import { isValidPhone } from '../../../../collums-components/helpers/validPhoneNumber';
import { toastr } from 'react-redux-toastr';

const SendSmsModal = ({ classes, onClose, createForm, customer, showFormSelector = false }) => {
    const defaultFormEmailContent = `<p style="text-align: center;">Hi ${customer?.firstName}</p><p style="text-align: center;">Please click the button below to view or complete your document.</p><p style="text-align: center;"><a style="background: #414141; color: #ffffff; padding: 10px 25px; border-radius: 3px;" href="{targetUrl}">View/complete your document</a></p>`;
    //eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false);
    const [form, setForm] = useState();
    const [subject, setSubject] = useState(showFormSelector ? '' : 'Please complete/review your form');
    const [smsTo, setSmsTo] = useState(customer?.mobilePhone || '');
    const [availableForms, setAvailableForms] = useState([]);
    const [content, setContent] = useState('');
    const editorRef = useRef(null);
    const globalStyles = makeStyles(modalsButtonStyles)();
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState();
    const [templateIndex, setTemplateIndex] = useState('');
    const [loadingUpload, setLoadingUpload] = useState({ visible: false, status: 'loading' });
    const [selectionPosition, setSelectionPosition] = useState(0);

    const loadTemplates = () => {
        TemplatesApi.getTemplates({
            type: 'sms'
        }).then(res => setEmailTemplates(res.data));
    };

    const fetchAllForms = () => {
        getAllFormsByType(
            queryString.stringify({
                type: 'All'
            })
        ).then(res => setAvailableForms(res));
    };

    useEffect(() => {
        loadTemplates();
        fetchAllForms();
    }, []);

    useEffect(() => {
        if (!selectedTemplate) return;
        emailTemplates.forEach((template, index) => {
            if (template.name === selectedTemplate.name) {
                setTemplateIndex(index);
            }
        });
        //eslint-disable-next-line
    }, [emailTemplates]);

    const handleSend = () => {
        let numberToCheck = smsTo.replace(/^test-/, '').replace(/-test$/, '');
        if (numberToCheck.startsWith('44')) {
            numberToCheck = '+' + numberToCheck;
        }
        if (!isValidPhone(numberToCheck)) {
            toastr.error('Invalid phone number.');
            return;
        }
        setIsLoading(true);
        createForm({ content, smsTo });
    };

    const customButtons = (
        <>
            <Button onClick={() => onClose()} className={globalStyles.cancelButton}>
                Cancel
            </Button>
            <Button
                disabled={!(subject && content) || isLoading}
                onClick={handleSend}
                className={`${globalStyles.baseButton} ${classes.actionButtonCompleteForm}`}
            >
                Send
            </Button>
        </>
    );

    const filterOptions = createFilterOptions({
        stringify: option => option.name
    });

    return (
        <>
            {isLoading && <LoadingScreen />}
            <Modal
                id="send-sms-modal"
                isOpen
                size="md"
                onCancel={() => onClose()}
                title="Send SMS"
                customButtons={customButtons}
                scrollableContent
                disableEnforceFocus
            >
                <Grid container direction="row">
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                        <Grid item xs={6}>
                            <TextField
                                id={'sms-to'}
                                label="SMS to"
                                value={smsTo}
                                variant="outlined"
                                fullWidth
                                onChange={e => setSmsTo(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    {showFormSelector && (
                        <Grid container item xs={12} alignItems="center">
                            <Grid item xs={5}>
                                <Autocomplete
                                    id="form-selector"
                                    className={classes.templateAutocomplete}
                                    options={
                                        availableForms.sort((a, b) => {
                                            if (a.name.toLowerCase() < b.name.toLowerCase()) {
                                                return -1;
                                            }
                                            if (a.name.toLowerCase() > b.name.toLowerCase()) {
                                                return 1;
                                            }
                                            return 0;
                                        }) || []
                                    }
                                    getOptionLabel={option => option.name}
                                    value={form}
                                    onChange={(_, value) => {
                                        // formRef.current = undefined; CHANGE HERE
                                        setContent(defaultFormEmailContent);
                                        setForm(value);
                                    }}
                                    filterOptions={customDropdownSearch}
                                    style={{ width: '100%' }}
                                    renderInput={params => <TextField {...params} variant="outlined" label="Form" />}
                                    renderOption={option => (
                                        <Typography style={{ fontSize: 14 }}>{option.name}</Typography>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}
                    {showFormSelector && (
                        <Grid container item xs={12} alignItems="center">
                            <Grid item xs={5}>
                                <Autocomplete
                                    className={classes.templateAutocomplete}
                                    options={emailTemplates.map((t, i) => ({ ...t, index: i }))}
                                    getOptionLabel={option => option.name}
                                    value={
                                        templateIndex === ''
                                            ? null
                                            : emailTemplates[templateIndex]
                                            ? { ...emailTemplates[templateIndex], index: templateIndex }
                                            : null
                                    }
                                    filterOptions={filterOptions}
                                    onChange={(e, newValue) => {
                                        if (!newValue) {
                                            setSelectedTemplate();
                                            setTemplateIndex('');
                                            return;
                                        }

                                        const value = newValue.index;

                                        if (editorRef && editorRef.current) {
                                            let content = emailTemplates[value].content;
                                            content = content
                                                .replace('{ClientFirstName}', customer?.firstName)
                                                .replace(
                                                    '{FormLink}',
                                                    '<p style="text-align: center;"><a style="background: #414141; color: #ffffff; padding: 10px 25px; border-radius: 3px;" href="{targetUrl}">View/complete your document</a></p>'
                                                );
                                            editorRef.current.value = content;
                                            setContent(content);
                                        }
                                        // setMessage(emailTemplates[value].content);

                                        if (emailTemplates[value]?.subject) {
                                            setSubject(emailTemplates[value].subject);
                                        }

                                        setSelectedTemplate(emailTemplates[value]);
                                        setTemplateIndex(value);
                                        // setHaveEmailUnsavedChanges(true);
                                    }}
                                    style={{ width: '100%' }}
                                    renderInput={params => (
                                        <TextField {...params} variant="outlined" label="Template" />
                                    )}
                                    renderOption={option => (
                                        <Typography style={{ fontSize: 14 }}>{option.name}</Typography>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <SMSEditor
                            setLoadingUpload={setLoadingUpload}
                            loadingUpload={loadingUpload}
                            editorRef={editorRef}
                            smsMessage={content}
                            setSMSMessage={setContent}
                            haveUnsavedChanges={() => () => {}}
                            setSelectionPosition={setSelectionPosition}
                            selectionPosition={selectionPosition}
                        />
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
};

SendSmsModal.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    createForm: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    showFormSelector: PropTypes.bool
};

export default withStyles(FormModalStyles)(SendSmsModal);
